<div [ngSwitch]="type">
  <mat-form-field *ngSwitchCase="'textarea'" appearance="outline" floatLabel="never" [ngClass]="classes">
    <textarea matInput class="textArea" [formControl]="control" [placeholder]="placeholder"></textarea>
    <mat-hint *ngIf="hint" align="end">{{hint}}</mat-hint>
    <mat-error *ngIf="control.touched && control.hasError('required')">{{ placeholder }} is required
    </mat-error>
  </mat-form-field>

  <div *ngIf="showHeader" class="place-holder-text semi-bold">{{ placeholder }} <div *ngIf="isRequired"
      class="required-field">*</div>
  </div>
  <mat-form-field *ngSwitchCase="'number'" appearance="outline" floatLabel="never" [ngClass]="classes">
    <input matInput [formControl]="control" [placeholder]="placeholder" (keyup)="onKeyUp($event)" type="number" />

    <span *ngIf="prefixIcon" matPrefix>
      <mat-icon [svgIcon]="prefixIcon"></mat-icon>
    </span>

    <span *ngIf="suffixIcon" matSuffix>
      <mat-icon [svgIcon]="suffixIcon"></mat-icon>
    </span>

    <span *ngIf="suffixText" class="suffixText" matSuffix (click)="onSuffixTextClicked()">
      {{ suffixText }}
    </span>

    <mat-hint *ngIf="hint" align="end">{{hint}}</mat-hint>

    <mat-error *ngIf="control.touched && control.hasError('required')">{{ placeholder }} is required
    </mat-error>
  </mat-form-field>

  <div *ngSwitchDefault>
    <div class="place-holder-text semi-bold">{{ placeholder }} <div *ngIf="isRequired" class="required-field">*</div>
    </div>
    <mat-form-field appearance="outline" floatLabel="never" [ngClass]="classes">
      <input matInput [formControl]="control" [placeholder]="hintText" [type]="type" (keyup)="onKeyUp($event)" />

      <span *ngIf="prefixIcon" matPrefix>
        <mat-icon [svgIcon]="prefixIcon"></mat-icon>
      </span>

      <span *ngIf="suffixIcon" matSuffix>
        <mat-icon [svgIcon]="suffixIcon"></mat-icon>
      </span>

      <span *ngIf="suffixText" class="suffixText" matSuffix (click)="onSuffixTextClicked()">
        {{ suffixText }}
      </span>

      <mat-hint *ngIf="hint" align="end">{{hint}}</mat-hint>

      <mat-error *ngIf="control.touched && control.hasError('required')">{{ placeholder }} is required
      </mat-error>
      <mat-error *ngIf="control.touched && control.hasError('comma')">Replace ',' with a ';' to add another {{
        placeholder }}</mat-error>
    </mat-form-field>
  </div>
</div>